import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=39ef9482&scoped=true&"
var script = {}
import style0 from "./Grid.vue?vue&type=style&index=0&id=39ef9482&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ef9482",
  null
  
)

export default component.exports